import { ShieldCheck } from "lucide-react";
import agentLars from "@/assets/agent-lars.jpg";
import type { LeadData } from "./types";
import { LeadForm } from "./LeadForm";

export function Hero({ onSubmit }: { onSubmit: (d: LeadData) => void }) {
  return (
    <section
      id="top"
      className="relative overflow-hidden text-primary-foreground"
      style={{ background: "var(--gradient-hero)" }}
    >
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: "radial-gradient(circle at 20% 20%, white 1px, transparent 1px), radial-gradient(circle at 80% 60%, white 1px, transparent 1px)",
        backgroundSize: "40px 40px",
      }} />
      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col">
          <div className="mb-6 inline-flex w-fit items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-medium tracking-wide text-white/80 backdrop-blur">
            <ShieldCheck className="h-3.5 w-3.5 text-gold" /> Spezialkanzlei seit 2008
          </div>
          <h1 className="text-4xl font-bold leading-[1.05] tracking-tight md:text-5xl lg:text-6xl">
            Wiederbeschaffung Ihres Kapitals nach Anlagebetrug.
          </h1>
          <p className="mt-5 max-w-xl text-base text-white/75 md:text-lg">
            Spezialisiert auf Krypto-Scams und betrügerische Handelsplattformen.
            Wir bringen Licht ins Dunkel und kämpfen für Ihr Recht.
          </p>

          <div className="mt-10 flex max-w-md items-center gap-4 rounded-xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
            <img
              src={agentLars}
              alt="Lars Koch, Leitender Experte für Fraud-Recovery"
              width={64}
              height={64}
              className="h-16 w-16 rounded-lg object-cover"
            />
            <div>
              <p className="font-semibold">Lars Koch</p>
              <p className="text-sm text-white/70">Leitender Experte für Fraud-Recovery</p>
            </div>
          </div>
        </div>

        <div id="kontakt" className="lg:justify-self-end w-full max-w-md justify-self-center">
          <LeadForm onSubmit={onSubmit} />
        </div>

      </div>
    </section>
  );
}